import "./styles/app.css";
import { mount } from "svelte";
import Game from "./ui/Game.svelte";

const target = document.getElementById("app");
if (!target) throw new Error("missing #app mount point");

mount(Game, { target });
